<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
          class="grey lighten-5"
          style="height: 300px;"
        >
          <v-card class="ma-3 pa-6">
            <v-card-title>Grant Admin Privilege</v-card-title>
            <v-card-actions>
              <grantAdminModal />
            </v-card-actions>
          </v-card>
          <v-card
            dark
            class="ma-3 pa-6"
            color='blue'
          >
            <v-card-title>Add new admin user</v-card-title>

            <v-card-actions>
              <addUserModel userType='admin' />
            </v-card-actions>
          </v-card>
          <v-card class="ma-3 pa-6">
            <v-card-title>Add new patient</v-card-title>
            <v-card-actions>
              <addUserModel userType='patient' />
            </v-card-actions>
          </v-card>

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import grantAdminModal from "../components/addUsers/grantAdminModal"
import addUserModel from '../components/addUsers/addUserModal'

export default {

  components: {
    addUserModel,grantAdminModal
  },

  data () {
    return {

    }
  }
}
</script>